import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AEROMEGH_SERVICES, STATUS, QUEUE_ORDER_STATUS } from "../../appConstants";
import { AcceptBesRequestUpdateAPI, CancelBesRequestAPI } from "../../apis/requests";
import { ROUTES } from "../../routes";
import Loading from "../../ReusableFunctions/Loader";
import Popup from "../../ReusableFunctions/Popup";
import SelectComponent from "../../ReusableComponents/SelectComponent";
import infoblackbg from "../../assets/Infoblackbg.svg";

export default function RequestDetailsHeader({
    setPopupState,
    request,
    onRequestUpdate,
    sprayingRequest,
    selectedStatus,
    setSelectedStatus,
}) {

    const nevigate = useNavigate();
    const statusOrder = [
        // STATUS.PLACED,
        STATUS.ACCEPTED,
        STATUS.CANCELLED
    ];
    console.log(sprayingRequest);
    const statusDropdownOptions = [];

    statusOrder.forEach((status) => {
        if (status === selectedStatus) {
            statusDropdownOptions.push({
                label: selectedStatus,
                value: selectedStatus,
                isDisabled: true,
            });
        }
        // Accept
        if (status === STATUS.ACCEPTED && request?.status === QUEUE_ORDER_STATUS.NOACTION && request?.user != null) {
            statusDropdownOptions.push({
                label: "Accept",
                value: STATUS.ACCEPTED,
                action: async () => {
                    try {
                        Loading.set(true);
                        let { request } = await AcceptBesRequestUpdateAPI(
                            sprayingRequest?.id,
                        );
                        console.log("updated request", request);
                        setSelectedStatus(QUEUE_ORDER_STATUS.ACCEPTED);
                        onRequestUpdate("Accepted", request, QUEUE_ORDER_STATUS.ACCEPTED);
                    } catch (err) {
                        Loading.set(false);
                        console.log("error", err);
                        Popup.alert("ERROR", err, "ERROR");
                    }
                },
                isDisabled: false,
            })
        }

        // Cancel
        else if (status === STATUS.CANCELLED && request?.user != null && [QUEUE_ORDER_STATUS.NOACTION].includes(request?.status)) {
            statusDropdownOptions.push({
                label: "Reject",
                value: STATUS.CANCELLED,
                action: async () => {
                    try {
                        Loading.set(true);
                        let { request } = await CancelBesRequestAPI(
                            sprayingRequest?.id,
                        );
                        setSelectedStatus(STATUS.CANCELLED)
                        onRequestUpdate("Cancel", request, QUEUE_ORDER_STATUS.REJECTED);
                    } catch (err) {
                        console.log("error", err);
                        Popup.alert("ERROR", err, "ERROR");
                        Loading.set(false);
                    }
                },
                isDisabled: false,
            })
        }
    });

    // Handle Dropdown Selection
    const handleStatusChange = async (selectedValue) => {
        const selected = statusDropdownOptions.find(opt => opt.value === selectedValue);
        if (selected && selected.action) {
            try {
                await selected.action();
            }
            catch (err) {
                Loading.set(false);
                console.error(err);
                Popup.alert("ERROR", "Something went wrong", "ERROR");
            }
        }
    }
    useEffect(() => {
        let updatedStatus = request?.status === QUEUE_ORDER_STATUS.NOACTION ? "Placed" : request?.status === QUEUE_ORDER_STATUS.EXPIRED || request?.status === QUEUE_ORDER_STATUS.CANCELLEDBYFARMER ? "Not Available" : request?.status === QUEUE_ORDER_STATUS.OTHERDSP ? "Missed" : request?.status === QUEUE_ORDER_STATUS.REJECTED ? "Rejected" : request?.status === QUEUE_ORDER_STATUS.CANCELLEDBYOPRATIONS || request?.status === QUEUE_ORDER_STATUS.MISSEDBYFARMER? "Cancelled" : request?.status;
        setSelectedStatus(updatedStatus);
    }, [request, request?.status]);
    console.log(request);

    return (
        <div className="flex justify-between items-center  px-4 py-5 border-b  border-b-[#D9D9D9] ">
            <h4 className="font-manrope font-[700] ml-[8px] text-[18px] text-[#1E1E1E]">
                Request Details
            </h4>
            <div className="mr-10 flex gap-4 items-center">
                {/*note*/}
                <div>
                    {(request?.status === QUEUE_ORDER_STATUS.OTHERDSP || request?.status === QUEUE_ORDER_STATUS.MISSEDBYFARMER) &&
                        (<span className="border px-4 py-1 rounded-lg border-gray-400 bg-[#3B3B3B1A] flex justify-center text-sm">
                            <img src={infoblackbg} alt="info_image" className="pe-1 w-5 h-5" /> No Action Taken / Missed
                        </span>)
                    }
                    {(request?.status === QUEUE_ORDER_STATUS.EXPIRED || request?.status === QUEUE_ORDER_STATUS.CANCELLEDBYFARMER) &&
                        (<span className="border px-4 py-1 rounded-lg border-gray-400 bg-[#3B3B3B1A] flex justify-center text-sm">
                            <img src={infoblackbg} alt="info_image" className="pe-1 w-5 h-5" /> Order no longer available
                        </span>)
                    }
                    {request?.status === QUEUE_ORDER_STATUS.REJECTED &&
                        (<span className="border px-4 py-1 rounded-lg border-gray-400 bg-[#3B3B3B1A] flex justify-center text-sm">
                            <img src={infoblackbg} alt="info_image" className="pe-1 w-5 h-5" /> You have rejected this order
                        </span>)
                    }
                    {request?.status === QUEUE_ORDER_STATUS.CANCELLEDBYOPRATIONS &&
                        (<span className="border px-4 py-1 rounded-lg border-gray-400 bg-[#3B3B3B1A] flex justify-center text-sm">
                            <img src={infoblackbg} alt="info_image" className="pe-1 w-5 h-5" /> Order no longer available
                        </span>)
                    }
                </div>
                {
                    !request ? (
                        <div
                            style={{
                                color: "#3B3B3B",
                                maxWidth: "400px",
                                wordWrap: "break-word",
                                lineHeight: 1.1,
                                fontSize: "13px",
                            }}
                        >
                            Request not found.
                        </div>
                    ) :
                        request?.user == null ? (
                            <div
                                style={{
                                    color: "crimson",
                                    maxWidth: "400px",
                                    wordWrap: "break-word",
                                    lineHeight: 1.1,
                                    fontSize: "13px",
                                }}
                            >
                                Request cannot be modified as the user has deleted their account.
                            </div>
                        ) : null}

                {
                    request?.user != null && ![STATUS.CANCELLED, STATUS.PAID,QUEUE_ORDER_STATUS.MISSEDBYFARMER,QUEUE_ORDER_STATUS.CANCELLEDBYFARMER, QUEUE_ORDER_STATUS.EXPIRED, QUEUE_ORDER_STATUS.OTHERDSP, QUEUE_ORDER_STATUS.REJECTED, QUEUE_ORDER_STATUS.CANCELLEDBYOPRATIONS].includes(sprayingRequest?.status) &&
                    <div className="flex items-center">
                        <p className="me-3">Status : </p>
                        <SelectComponent
                            list={statusDropdownOptions}
                            onChange={(status) =>
                                handleStatusChange(status.value)
                            }
                            isDisabled={request?.status === QUEUE_ORDER_STATUS.EXPIRED || request?.status === QUEUE_ORDER_STATUS.CANCELLEDBYFARMER || request?.status === QUEUE_ORDER_STATUS.MISSEDBYFARMER || request?.status === QUEUE_ORDER_STATUS.OTHERDSP || request?.status === QUEUE_ORDER_STATUS.REJECTED ? true : false}
                            controlStyle={{ height: "40px", width: "200px", minHeight: "20px", border: "1px solid black", color: "hsl(0deg 0% 20% / 64%)" }}
                            value={selectedStatus ? { value: selectedStatus, label: selectedStatus } : null}
                        />
                    </div>
                }
            </div>
        </div>
    );
}
